<template>
  <div class="flex-container view-port" v-bind:class="{ center: !isMobile }">
    <div v-if="isMobile" class="mobile-top-nav header-2">Contact</div>

    <div class="contact-box">
      <div class="mg-55" v-if="isMobile" />
      <div
        style="font:normal normal 400 12px/normal dotum, sans-serif;width: 500px; height:700px;   color:#333; position:relative"
        v-if="!isMobile"
      >
        <div style="height: 668px;">
          <a
            href="https://map.kakao.com/?urlX=558425.0&amp;urlY=830563.0&amp;itemId=1302101635&amp;q=%EB%8D%B0%EC%9D%B4%ED%84%B0%EB%AA%AC%EC%8A%A4%ED%84%B0%EC%A6%88&amp;srcid=1302101635&amp;map_type=TYPE_MAP&amp;from=roughmap"
            target="_blank"
          >
            <img
              class="map"
              src="//t1.daumcdn.net/roughmap/imgmap/255aa0aff586f60a57ad5eae229ac234f16f4d71537a3849418f3d24a17f8a5a"
              width="498px"
              height="666px"
              style="border:1px solid #ccc;"
            />
          </a>
        </div>
        <div
          style="overflow: hidden; padding: 7px 11px; border: 1px solid rgba(0, 0, 0, 0.1); border-radius: 0px 0px 2px 2px; background-color: rgb(249, 249, 249);"
        >
          <a href="https://map.kakao.com" target="_blank" style="float: left;">
            <img
              src="//t1.daumcdn.net/localimg/localimages/07/2018/pc/common/logo_kakaomap.png"
              width="72"
              height="16"
              alt="카카오맵"
              style="display:block;width:72px;height:16px"
            />
          </a>
          <div
            style="float: right; position: relative; top: 1px; font-size: 11px;"
          >
            <a
              target="_blank"
              href="https://map.kakao.com/?from=roughmap&amp;srcid=1302101635&amp;confirmid=1302101635&amp;q=%EB%8D%B0%EC%9D%B4%ED%84%B0%EB%AA%AC%EC%8A%A4%ED%84%B0%EC%A6%88&amp;rv=on"
              style="float:left;height:15px;padding-top:1px;line-height:15px;color:#000;text-decoration: none;"
              >로드뷰</a
            >
            <span
              style="width: 1px;padding: 0;margin: 0 8px 0 9px;height: 11px;vertical-align: top;position: relative;top: 2px;border-left: 1px solid #d0d0d0;float: left;"
            ></span>
            <a
              target="_blank"
              href="https://map.kakao.com/?from=roughmap&amp;eName=%EB%8D%B0%EC%9D%B4%ED%84%B0%EB%AA%AC%EC%8A%A4%ED%84%B0%EC%A6%88&amp;eX=558425.0&amp;eY=830563.0"
              style="float:left;height:15px;padding-top:1px;line-height:15px;color:#000;text-decoration: none;"
              >길찾기</a
            >
            <span
              style="width: 1px;padding: 0;margin: 0 8px 0 9px;height: 11px;vertical-align: top;position: relative;top: 2px;border-left: 1px solid #d0d0d0;float: left;"
            ></span>
            <a
              target="_blank"
              href="https://map.kakao.com?map_type=TYPE_MAP&amp;from=roughmap&amp;srcid=1302101635&amp;itemId=1302101635&amp;q=%EB%8D%B0%EC%9D%B4%ED%84%B0%EB%AA%AC%EC%8A%A4%ED%84%B0%EC%A6%88&amp;urlX=558425.0&amp;urlY=830563.0"
              style="float:left;height:15px;padding-top:1px;line-height:15px;color:#000;text-decoration: none;"
              >지도 크게 보기</a
            >
          </div>
        </div>
      </div>
      <div class="contact-info">
        <p class="kor header-3 color-white bold">(주)데이터몬스터즈</p>
        <div class="mg-50" />
        <p class="text-2 color-white bold">위치</p>
        <p class="text-2 color-white">
          세종특별자치시 나성로 96 어반아트리움 P2 더센트럴 601, 611 호
        </p>
        <div class="space-15" />
        <p class="text-2 color-white bold">전화번호</p>
        <a class="text-2 color-white kor" href="tel:044-865-6038"
          >044-865-6038</a
        >
        <div class="space-15" />
        <p class="text-2 color-white bold">이메일</p>
        <a class="text-2 color-white kor" href="mailto:contact@damons.kr"
          >contact@damons.kr</a
        >
        <div class="space-15" />
        <a
          class="text-2 color-white kor bold underline"
          href="https://drive.google.com/file/d/1fZ5Mw2qqiAPpYoWTM8OTvKZwJ-q4Ybtu/view?usp=sharing"
          >건물 내 찾아오시는 길 >></a
        >

        <div class="mg-25" />
        <div class="space-15" />
        <p class="header-3 kor color-white bold">문의</p>

        <v-form v-model="valid">
          <v-row>
            <v-col cols="12" md="12">
              <v-radio-group :rules="requiredRules" row v-model="type">
                <v-radio
                  v-for="type in contactTypes"
                  dark
                  :key="type.value"
                  :label="type.label"
                  :value="type.value"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="name"
                label="*이름"
                required
                :rules="requiredRules"
                dark
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="company"
                label="회사명"
                dark
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="email"
                label="*이메일"
                type="mail"
                required
                :rules="emailRules"
                dark
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="content"
                label="*내용"
                required
                :rules="requiredRules"
                dark
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-spacer />
            <v-btn color="primary" width="200px" @click="sendContact"
              >보내기</v-btn
            >
            <v-spacer />
          </v-row>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
  data: () => ({
    valid: false,
    name: null,
    company: null,
    content: null,
    email: null,
    type: null,
    koreanType: null,
    requiredRules: [(v) => !!v || "필수 입력 값입니다."],
    emailRules: [
      (v) => !!v || "필수 입력 값입니다.",
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "올바른 형식의 이메일을 입력해주세요.",
    ],
    contactTypes: [
      {
        label: "프로젝트",
        value: "PROJECT",
      },
      {
        label: "강의",
        value: "SEMINAR",
      },
      {
        label: "제휴",
        value: "ALIANCE",
      },
      {
        label: "데이터바우처",
        value: "VOUCHER",
      },
      {
        label: "기타",
        value: "ETC",
      },
    ],
  }),
  methods: {
    sendContact() {
      if (!this.valid) {
        alert("정보를 모두 입력 해주세요.");
        return;
      }

      switch (this.type) {
        case 'PROJECT':
          this.koreanType = '프로젝트';
          break;
        case 'SEMINAR':
          this.koreanType = '강의/세미나';
          break;
        case 'ALIANCE':
          this.koreanType = '제휴';
          break;
        case 'VOUCHER':
          this.koreanType = '데이터 바우처';
          break;
        case 'ETC':
          this.koreanType = '기타';
          break;
        default:
          alert("유효하지 않은 문의 종류입니다.");
          return;
      }

      axios
        .post(
          "https://r12mhbgc1a.execute-api.ap-northeast-2.amazonaws.com/dev/sendContactMail",
          JSON.stringify({
            name: this.name,
            contactType: this.koreanType,
            email: this.email,
            organization: this.company,
            inquiry: this.content,
          })
        )
        .then((res) => {
          if (res.error) {
            alert("Mail 오류가 발생했습니다:", res.error);
            return;
          } else {
            this.$apollo
              .mutate({
                mutation: require("../graphql/CreateContact.gql"),
                variables: {
                  name: this.name,
                  email: this.email,
                  companyName: this.company,
                  body: this.content,
                  type: this.type,
                },
              })
              .then((response) => {
                if (response.data.CreateContact.ok) {
                  alert("문의가 성공적으로 전달되었습니다!");
                } else {
                  alert(response.data.CreateContact.error);
                }
              })
              .catch((err) => {
                alert("GraphQL 오류가 발생했습니다:", err.message);
                return;
              });
          }
        })
        .catch((e) => {
          alert("오류가 발생했습니다:", e);
          return;
        });

      // this.$apollo
      //   .mutate({
      //     mutation: require("../graphql/CreateContact.gql"),
      //     variables: {
      //       name: this.name,
      //       email: this.email,
      //       companyName: this.company,
      //       body: this.content,
      //       type: this.type
      //     }
      //   })
      //   .then(response => {
      //     if (response.data.CreateContact.ok) {
      //       alert("전송되었습니다.");
      //     } else {
      //       alert(response.data.CreateContact.error);
      //     }
      //   })
      //   .catch(err => {
      //     alert(err.message);
      //   });
    },
  },
};
</script>

<style scoped>
* {
  line-height: 1.2;
}

p {
  margin-bottom: 0 !important;
}

.col-12 {
  padding-top: 0;
  padding-bottom: 0;
}

.contact-box {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
}

.contact-info {
  height: 700px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  background-color: rgba(45, 45, 45, 1);
  padding: 40px;
  min-width: 530px;
}

.underline {
  text-decoration: underline !important;
}

@media only screen and (max-width: 880px) {
  .contact-box {
    width: 100%;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
  }

  .contact-info {
    width: 100%;
    min-height: 780px;
    min-width: 0px;
  }
}
</style>
